import React from 'react';
import styles from './Links.module.scss';

interface LinksProps {
    website: string | null;
    facebook_link: string | null;
    instagram_link: string | null;
    pinterest_link: string | null;
}

const Links = ({ website, facebook_link, instagram_link, pinterest_link }: LinksProps) => {
    if (!website && !facebook_link && !instagram_link && !pinterest_link) {
        return null;
    }
    return (
        <div className={styles.Links}>
            <h2 className={styles.LinksTitle}>Links</h2>
            <div className={styles.LinksList}>
                {website && (
                    <a href={website} target='_blank' className={styles.LinksWebsite}>
                        VIEW WEBSITE
                    </a>
                )}
              
                {instagram_link && (
                    <a href={instagram_link} target='_blank' className={styles.LinksSocial}>
                        <i className='icon-hb-nx-instagram' />
                    </a>
                )}
                {pinterest_link && (
                    <a href={pinterest_link} target='_blank' className={styles.LinksSocial}>
                        <i className='icon-hb-nx-pinterest' />
                    </a>
                )}
            </div>
        </div>
    );
};

export default Links;
